export const UsersActionKeys = {
  SET_USERS: 'SET_USERS'
} as const;
